import FontBody1 from '../../../../../components/fonts/font-body1/font-body1';
import FontHeading4 from '../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../components/fonts/font-props';
import IconPlus from '../../../../../components/icons/icon-plus/icon-plus';
import { BUTTON_VARIANTS } from '../../../../../components/inputs/button-variants';
import { Button } from '../../../../../components/inputs/button/button';
import NoPolicies from '../../../../../images/no-policies.svg';
import './no-policy-rules.scss';

interface IProps {
    onAddPolicyClicked: () => void,
}

const NoPolicyRules: React.FC<IProps> = ({onAddPolicyClicked}) => {
    const iconComponent = () => <IconPlus color="var(--color-neutral-1-white)" />;
    
    return (
        <div className="no-policies-warning">
            <img src={NoPolicies} alt="" />
            <FontHeading4 color={FONT_COLOR.PRIMARY3} variant={FONT_VARIANT.BOLD}>No Policy Rules</FontHeading4>
            <FontBody1>
                Without Policy rules, the Return Portal will not work! <br />
                Add at least one policy rule.
            </FontBody1>
            <Button variant={BUTTON_VARIANTS.PrimaryAccent} leftIcon={iconComponent} text="Add Rule" onClick={onAddPolicyClicked} />
        </div>
    );
};

export default NoPolicyRules;